export const MY_ACCOUNT_DROPDOWN = [
  {
    name: 'My Tax Returns',
    href: '/filing/itr-filings',
  },
  {
    name: 'My Orders',
    href: '/services/my_orders',
  },
  {
    name: 'My Documents',
    href: '/services/library',
  },
  {
    name: 'Profile',
    href: '/filing/profile',
  },
  {
    name: 'Support',
    href: '/s/contact-us',
  },
  {
    name: 'Logout',
    href: '',
  },
];

export const SUPPORT_AGENT_DROPDOWN = [
  {
    name: 'Profile',
    href: '/filing/profile',
  },
  {
    name: 'Logout',
    href: '',
  },
];
